import React, { useState } from 'react';
import './DespreNoi.css'; // Fișier CSS pentru stilizare
import { motion } from 'framer-motion'; // Importă framer-motion

export default function DespreNoi() {
  const [message, setMessage] = useState('');

  const handleShowMessage = (msg) => {
    setMessage(msg);
  };

  const handleScrollToSection = (sectionId) => {
    document.getElementById(sectionId).scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <div className="despre-noi">
      {/* Header Section with fade-in effect */}
      <motion.header
        className="header-section"
        initial={{ opacity: 0, y: -50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 1 }}
      >
        <h1>Despre Noi - OptiZak</h1>
        <p>O companie dedicată sănătății vizuale</p>
        <div className="buttons">
          <button onClick={() => handleScrollToSection('intro')} className="btn btn-primary">Cine Suntem</button>
          <button onClick={() => handleScrollToSection('team')} className="btn btn-primary">Echipa Noastră</button>
          <button onClick={() => handleScrollToSection('mission-values')} className="btn btn-primary">Misiunea</button>
          <button onClick={() => handleScrollToSection('history')} className="btn btn-primary">Istoric</button>
          <button onClick={() => handleShowMessage('Mulțumim pentru vizită!')} className="btn btn-success">Afișează Mesaj</button>
        </div>
      </motion.header>

      {message && (
        <motion.div
          className="alert-message"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.5 }}
        >
          {message}
        </motion.div>
      )}

      <div className="container">
        {/* Cine Suntem Section with fade-in effect */}
        <motion.section
          id="intro"
          className="content-section"
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 1 }}
          viewport={{ once: true }}
        >
          <h2>Cine Suntem</h2>
          <p>
            OptiZak este lider în furnizarea de ochelari de vedere și servicii optice în Brașov. Cu o experiență de peste
            20 de ani, ne-am angajat să oferim produse de calitate și servicii personalizate fiecărui client.
          </p>
        </motion.section>

        {/* Echipa Noastră Section with zoom-in effect for team members */}
        <motion.section
          id="team"
          className="content-section"
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 1 }}
          viewport={{ once: true }}
        >
          <h2>Echipa Noastră</h2>
          <div className="row">
            {[
              {
                name: 'Camelia Zaharia',
                role: 'Optometrist cu o experienta in domeniul ingrijiri vizuale incepand din 1995',
                imgSrc: '/imagini/Camelia Zaharia.jpg'
              },
              {
                name: 'Dr. Petcu Mihai',
                role: 'Dr. Oftalmolog cu o experienta in domeniul ingrijiri vizuale incepand din 2012',
                imgSrc: '/imagini/D Mihai Petcu.jpg'
              },
              {
                name: 'Ungureanu Loredana',
                role: 'Optometrist cu o experienta in domeniul ingrijiri vizuale incepand din 2010',
                imgSrc: '/imagini/loredana Ungureanu.jpg'
              }
            ].map((member, index) => (
              <motion.div
                key={index}
                className="col-md-4 team-member"
                whileHover={{ scale: 1.1 }}
                transition={{ type: 'spring', stiffness: 300 }}
              >
                <img src={member.imgSrc} alt={`Membru echipă ${index + 1}`} className="team-img" />
                <h5>{member.name}</h5>
                <p>{member.role}</p>
              </motion.div>
            ))}
          </div>
        </motion.section>

        {/* Misiunea și Valorile Section with fade-in effect */}
        <motion.section
          id="mission-values"
          className="content-section"
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 1 }}
          viewport={{ once: true }}
        >
          <h2>Valorile și Misiunea Noastră</h2>
          <p><strong>Misiunea noastră:</strong> Să îmbunătățim vederea și calitatea vieții clienților noștri prin produse
            inovative și servicii de excepție.</p>
          <p><strong>Valorile noastre:</strong></p>
          <ul>
            <li>Calitate și profesionalism</li>
            <li>Grijă pentru sănătatea vizuală</li>
            <li>Respect, Empatie și Integritate</li>
            <li>Inovație și tehnologie</li>
          </ul>
        </motion.section>

        {/* Istoric Section with fade-in effect */}
        <motion.section
          id="history"
          className="content-section"
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 1 }}
          viewport={{ once: true }}
        >
          <h2>Istoricul Nostru</h2>
          <div className="timeline">
            {[
              { year: '2019', text: 'OptiZak a fost fondată în Brașov, oferind inițial servicii de optică pentru comunitatea locală.' },
      
            ].map((event, index) => (
              <motion.div
                key={index}
                className="timeline-item"
                initial={{ opacity: 0, x: -50 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 1 }}
                viewport={{ once: true }}
              >
                <h4>{event.year}</h4>
                <p>{event.text}</p>
              </motion.div>
            ))}
          </div>
        </motion.section>
      </div>
    </div>
  );
}
